'use strict';

var _assign = require('babel-runtime/core-js/object/assign');

var _assign2 = _interopRequireDefault(_assign);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

require('babel-polyfill');

var environment = {
  development: {
    isProduction: false
  },
  production: {
    isProduction: true
  }
}[process.env.NODE_ENV || 'development'];

module.exports = (0, _assign2.default)({
  host: process.env.HOST || 'localhost',
  port: process.env.PORT || 3000,
  instagramClientID: '432f7984e8374318b15c9687588f4f74',
  instagramRedirectURL: 'http://outfeats.com/api/auth', //'http://localhost:3030/auth',
  apiHost: process.env.APIHOST || 'localhost',
  apiPort: process.env.APIPORT || 3030,
  assetsUrl: 'https://d1drs6m9f14n1a.cloudfront.net/', //'https://s3.amazonaws.com/outfeats/',
  thumbnailAssetsUrl: 'https://d1xj8iltotrppj.cloudfront.net/', //'https://s3.amazonaws.com/outfeats-thumbnails/',
  app: {
    title: 'Outfeats',
    description: 'The easiest way to create and share your outfits. Outfits featuring you!',
    head: {
      titleTemplate: 'Outfeats',
      meta: [{ name: 'description', content: 'The easiest way to create and share your outfits. Outfits featuring you!' }, { charset: 'utf-8' }, { property: 'og:site_name', content: 'Outfeats' }, { property: 'og:image', content: '' }, { property: 'og:locale', content: 'en_US' }, { property: 'og:title', content: 'Outfeats' }, { property: 'og:description', content: 'The easiest way to create and share your outfits' }, { property: 'og:card', content: 'summary' }, { property: 'og:site', content: 'www.outfeats.com' }, { property: 'og:creator', content: '© Outfeats' }]
    }
  },
  slack: {
    SLACK_WEBHOOK: 'https://hooks.slack.com/services/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',
    CHANNEL: 'aws-bot'
  }
}, environment);


/*****************
 ** WEBPACK FOOTER
 ** ./src/config.js
 ** module id = 31
 ** module chunks = 0
 **/